import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav5").addClass("active")
var swiper = new Swiper(".mySwiper", {
  loop:true,
  // speed:2000,
  // autoplay: {
  //     delay: 3000,
  // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });